import React from 'react';

import './style.less';
import { Col, Row } from 'antd';

import carsSoldIcon from '_images/carousell-os-car-valuation-40k-cars-sold.svg';
import bidsReceivedIcon from '_images/carousell-os-car-valuation-75k-bids-received.svg';
import approvedDealerIcon from '_images/carousell-os-car-valuation-500p-approved-dealers.svg';

const carValuationData = [
  {
    icon: carsSoldIcon,
    iconAlt: 'Submit your details',
    count: 43500,
    label: 'Cars sold',
  },
  {
    icon: bidsReceivedIcon,
    iconAlt: 'Submit your details',
    count: 582500,
    label: 'Bids received',
  },
  {
    icon: approvedDealerIcon,
    iconAlt: 'Submit your details',
    count: 500,
    label: 'Approved dealers',
  },
];

const LeadPageProofSection = () => {
  return (
    <div className="lead-page-large-section">
      <Row gutter={[0, 40]}>
        {carValuationData.map((d, i) => (
          <Col xs={{ span: 24 }} sm={{ span: 8 }} key={i}>
            <div className="text-center">
              <img
                className="ml-auto mr-auto"
                alt={d.iconAlt}
                width="192"
                height="144"
                src={d.icon}
                loading="lazy"
              />
              <h3 className="mt-4 mb-0">{d.count.toLocaleString()}+</h3>
              <div className="os-text-24">{d.label}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LeadPageProofSection;
